import { createSlice } from "@reduxjs/toolkit";
import { logout } from "../common/reducers/initContext";
import { dataHookFactory } from '../common/reducers/utilities';
import { ensureArray } from "../common/utils/arrayUtilities";

const compareUsers = (u1, u2) => u1.username === u2.username

const userSlice = createSlice({
    name: 'users',
    initialState: {
        data: [],
        current: null,
    },
    reducers: {
        set: (state, action) => {
            state.data = action.payload
        },
        setCurrent: (state, action) => {
            state.current = action.payload;
        },
        addOrUpdate: (state, action) => {
            for (const user of ensureArray(action.payload)) {
                let idx = state.data.findIndex(s2 => compareUsers(user, s2));
                if (idx >= 0) {
                    state.data.splice(idx, 1, user);
                } else {
                    state.data.push(user);
                }
                if (state.current?.username === user.username) {
                    state.current = user;
                }
            }
        },
        remove: (state, action) => {
            for (const user of ensureArray(action.payload)) {
                let idx = state.data.findIndex(s => s.username === user.username);
                if (idx >= 0) {
                    state.data.splice(idx, 1);
                }
            }
        }
    },
    extraReducers: builder => {
        builder.addCase(logout, () => userSlice.getInitialState());
    }
});

// #region network operations
const fetchUsers = network => network.get('/api/v1/users', userSlice.actions.set);
const fetchCurrent = network => network.get('/api/v1/user', userSlice.actions.setCurrent);
export const createUser = (network, user) => network.post('/api/v1/createUser', user, userSlice.actions.addOrUpdate);
export const updateUser = (network, user) => network.put('/api/v1/user', user, userSlice.actions.addOrUpdate);
export const removeUser = (network, user) => network.delete('/api/v1/deleteUser/' + encodeURIComponent(user.username), userSlice.actions.remove);
export const updateUserRoles = (network, username, access) => network.put('/api/v1/roles/' + encodeURIComponent(username), access, userSlice.actions.addOrUpdate);
export const updateUserSitrepAccess = (network, username, access) => network.put('/api/v1/sitrepAccess/' + encodeURIComponent(username), access, userSlice.actions.addOrUpdate);
export const updateUserLogAccess = (network, username, access) => network.put('/api/v1/logAccess/' + encodeURIComponent(username), access, userSlice.actions.addOrUpdate);
export const changePassword = (network, currentPassword, newPassword) => network.post('/api/v1/changePassword', {currentPassword, newPassword}, userSlice.actions.addOrUpdate); // TODO this needs to provide a message saying the password was not udpated
export const resetPassword = (network, username, password) => network.post('/api/v1/resetUserPassword', {username, password}); // TODO this needs to provide a message saying the password was not udpated
export const enableWithPassword = (network, username, password) => network.post('/api/v1/enableUserWithPassword', {username, password}, userSlice.actions.addOrUpdate);
// #endregion

// #region permission checks
export const canUpdateUser = (credentials, user) => credentials.access.hasFull('administrator');
export const canCreateUser = (credentials, user) => credentials.access.hasFull('administrator');
export const canRemoveUser = (credentials, user) => credentials.access.hasFull('administrator');
// #endregion

// #region selectors
const selectUsers = state => state.users.data;
const selectCurrent = state => state.users.current;
// #endregion


export const [useUsers] = dataHookFactory(selectUsers, { run: fetchUsers });
export const [useCurrentUser] = dataHookFactory(selectCurrent, { run: fetchCurrent });

const reducerDetails = { name: userSlice.name, reducer: userSlice.reducer };
export default reducerDetails;